<template>
  <!--  <div v-on:wheel="wheelHandler">-->
  <div>
    <transition v-on:before-leave="leaveStart" :duration="1000">

      <Start :anim.sync="startanim" v-if="activeslide===-1" phase3.sync="phase3"></Start>
    </transition>
    <Scrollbutton @click.native="goDown" :class="{active:activeslide>-1}"
                  v-if="activeslide +1 < slides.length "></Scrollbutton>
    <div class="slidecontainer">
      <div v-for="s in slides" class="slide" :key="s.header">
        <div class="slideimg" :style="{ backgroundImage: `url(${s.hintergrund.sizes.large})`}">
        </div>
        <div class="slidewrap">
          <h2 class="h2 zzgray slideheader">
            <div style="font-size: 22px;line-height: 24px;font-weight:300;"
                 v-if="s.second&&s.over" v-html="s.second">
            </div>
            <span v-html="s.header"></span>
            <div style="font-size: 22px;line-height: 24px;font-weight: 300;"
                 v-if="s.second&&!s.over" v-html="s.second">
            </div>
          </h2>
          <div v-html="s.text" class="slidecontent"></div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import Start from '@/components/Start.vue'
import Velocity from "velocity-animate";
import Scrollbutton from '@/components/parts/Scrollbutton.vue'

const slugify = require('slugify')
export default {
  Velocity,
  store,
  components: {
    Start, Scrollbutton
  },
  name: "Slidesmobile",
  data() {
    return {
      startanim: false,
      phase3: false
    }
  },
  methods: {
    wheelHandler(e) {
      if (e.deltaY > 0) {
        if (this.slides.length > this.activeslide + 1) {
          this.goDown();
        } else if (this.slides.length === this.activeslide + 1) {
          return false;
        }
      }
      if (e.deltaY < 0) {
        if (this.activeslide === 0) {
          this.$router.push('/');
        } else {
          this.goUp()
        }
      }
    },
    goUp() {
      this.$router.push({
        name: 'Slides',
        params: {slide: this.slugify(this.slidemenu[this.activeslide - 1])}
      })
    },
    goDown() {
      this.$router.push({
        name: 'Slides',
        params: {slide: this.slugify(this.slidemenu[this.activeslide + 1])}
      })
    },
    slugify(str) {
      return str ? slugify(str, {lower: true}) : '';
    },
    leaveStart(el) {
      let cover = el.querySelector('.cover');
      if (cover) {

        cover.velocity({
          height: ['0', '50vh'],
          opacity: [0, 1]
          // width: [50 % 0]
        }, {
          duration: 1000,
          delay: 0
        })
      }
    }
  },
  computed: {
    slides: () => store.state.slides,
    slidemenu: () => store.state.slides.map(s => s.teaser),
    activeslide: function () {
      if (this.$route.meta.team === true) {
        return this.slides.length
      }
      let slug = this.$route.params.slide
      let slides = store.state.slides.map(s => this.slugify(s.teaser))
      return slides.indexOf(slug) > -1 ? slides.indexOf(slug) : -1;
    },
  },
  watch: {
    activeslide() {
      this.activeslide === -1 ? document.body.classList.add('nooverflow') : document.body.classList.remove('nooverflow')
    }
  },
  mounted() {

    this.activeslide === -1 ? document.body.classList.add('nooverflow') : document.body.classList.remove('nooverflow')
  },
}
</script>
<style scoped lang="scss">
.slide {
  background-color: #f2f2f2;

  h2 {
    line-height: 30px;
    font-weight: 400;
  }

  .slideimg {
    height: 300px;
    margin: 50px 0 0;
    width: 100%;
    background-size: cover;
    background-position: center center;
  }

  &:first-child {
    .slideimg {
      margin-top: 0;
    }
  }
}


.slidewrap {
  padding: 50px 5% 0 20%;
}


.slidecontent {
  font-size: 18px;
  line-height: 26px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0.02em;
  text-align: left;
}

.slidecontainer {
  /*overflow: scroll;*/
  /*height: 100vh;*/
  padding-top: 72px;
  padding-bottom: 100px;
}


</style>